import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import api from "@/api";
import * as utils from "@/utils";
import { auth } from "@/firebase";

import moment from "moment";
import VueCurrencyFilter from "vue-currency-filter";
import vueFilterPrettyBytes from "vue-filter-pretty-bytes";

import mondaySdk from "monday-sdk-js";

Vue.config.productionTip = false;
Vue.prototype.moment = moment;
Vue.use(VueCurrencyFilter, {
  symbol: "",
  thousandsSeparator: ",",
  fractionCount: 2,
  fractionSeparator: ".",
  symbolPosition: "front",
  symbolSpacing: true,
  avoidEmptyDecimals: "",
});
Vue.use(vueFilterPrettyBytes);

Vue.prototype.$api = api;
Vue.prototype.$utils = utils;
Vue.prototype.monday = mondaySdk();

let app;
auth.onAuthStateChanged(async (user) => {
  if (!app) {
    let res = await Vue.prototype.monday.api(
      "query { me { id name email country_code location url account { id name } } }"
    );
    Vue.prototype.isInMonday = !!res;
    Vue.prototype.mdUser = (Vue.prototype.isInMonday) ? res.data.me : {};
    console.log("isInMonday", Vue.prototype.isInMonday);

    app = new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount("#app");
  }

  if (user) {
    user.id = user.uid;
    store.dispatch("refreshUserProfile", user);
  }
});
